/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_UnavailableInputs */

const vi_error_kiotviet_unavailable = /** @type {(inputs: Error_Kiotviet_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lấy được dữ liệu từ KiotViet. Thử lại sau ít phút.`)
};

/**

* @param {Error_Kiotviet_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_unavailable = /** @type {((inputs?: Error_Kiotviet_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_unavailable(inputs)
});